module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('breadcrumbs', {
    attrs: {
      "crumbs": ['Organization Dashboard']
    }
  }, [(!_vm.loading && _vm.user.access > 2) ? _c('span', {
    staticClass: "pull-right options-gear margin-right-10 margin-top-10",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showEditWidgetsModal.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon-settings right"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 db-column",
    attrs: {
      "id": "first-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsFirst,
      "draggable": ".dragme",
      "type": 'widgetsFirst'
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 db-column",
    attrs: {
      "id": "second-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsSecond,
      "draggable": ".dragme",
      "type": 'widgetsSecond'
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1)])]) : _c('spinner'), _vm._v(" "), _c('edit-widgets-modal', {
    attrs: {
      "widgets": _vm.enabledWidgetsMap
    },
    on: {
      "save": _vm.widgetsSaved
    },
    model: {
      value: (_vm.showEditModal),
      callback: function($$v) {
        _vm.showEditModal = $$v
      },
      expression: "showEditModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9226785c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DashboardOrganization.vue
// module id = 1722
// module chunks = 1